import { render, staticRenderFns } from "./Valores.vue?vue&type=template&id=37e1742a&lang=pug&"
import script from "./Valores.vue?vue&type=script&lang=js&"
export * from "./Valores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports